import React from 'react'
import ReactDOM from 'react-dom'
import CmsPanel from '../components/admin/cms_panel/CmsPanel'

console.debug(
  'bedsider/app/javascript/packs/admin/cms_panel/CmsPanel.js loaded'
)

const animateStyles = {
  width: '390px',
  opacity: 0.9,
}

const setupCmsPanel = () => {
  const animateCallback = () => {
    $('#cms_panel .close_box').show()
    $('#cms_panel .content_editor').fadeIn('fast')
  }

  // document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cms_panel_editable').forEach((elem) => {
    elem.addEventListener('click', (event) => {
      if (!event.shiftKey) return

      event.preventDefault()

      // Open the side panel
      $('#cms_panel')
        .css('width', 0)
        .css('opacity', 0.5)
        .show()
        .animate(animateStyles, 'fast', animateCallback)

      // Render <CmsPanel> into it
      const contentPage = elem.getAttribute('data-content-page')
      const contentKey = elem.getAttribute('data-content-key')
      const editingElement = elem

      ReactDOM.render(
        <CmsPanel
          contentPage={contentPage}
          contentKey={contentKey}
          editingElement={editingElement}
        />,
        document.querySelector('#cms_panel .content_editor')
      )
    })
  })

  // eslint-disable-next-line func-names
  $('#cms_panel .close_box').click(function (event) {
    event.preventDefault()
    $(this).hide()
    // eslint-disable-next-line func-names
    $('#cms_panel').animate({ width: '0px' }, 'medium', function () {
      $(this).hide()
    })
  })
}

// jQ might not be loaded yet; wait until it is.
window.addEventListener('load', setupCmsPanel)
